export default __webpack_public_path__ + "static/media/right-bg.801c38d8.png";